import { styled } from 'styled-components';
import { BonusItem } from '../../styles';

const BonusItemBurns = styled(BonusItem)`
  height: 100%;
  border-radius: 0;
  padding: 16px;
`;

export const IconSpacingBox = styled.div`
  margin-top: 24px;
  margin-bottom: 24px;
`;

export const CenteredTitleBox = styled.div`
  text-align: center;
`;

export const CenteredDescBox = styled.div`
  text-align: center;
  margin-top: 8px;
  margin-bottom: 12px;
`;

export const ButtonsRow = styled.div`
  margin-top: 24px;
  display: flex;
  gap: 5px;
`;

export { BonusItemBurns };
